import { render, staticRenderFns } from "./ShareAward.vue?vue&type=template&id=93d20db0&scoped=true&"
import script from "./ShareAward.vue?vue&type=script&lang=js&"
export * from "./ShareAward.vue?vue&type=script&lang=js&"
import style0 from "./ShareAward.vue?vue&type=style&index=0&id=93d20db0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d20db0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93d20db0')) {
      api.createRecord('93d20db0', component.options)
    } else {
      api.reload('93d20db0', component.options)
    }
    module.hot.accept("./ShareAward.vue?vue&type=template&id=93d20db0&scoped=true&", function () {
      api.rerender('93d20db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/MarketingChildren/ShareAward.vue"
export default component.exports